import React, { useState, useEffect } from 'react';
import FormConfigurationValue from './FormConfigurationValue';
import { UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import { isMobile } from 'react-device-detect';
import ModalTaimesAgentMatrix from './ModalTaimesAgentMatrix';

const FormCreate = (props) => {
    const [showConfigurationValue, setShowConfigurationValue] = useState(false);
    const [modalTaimesMatrix, setModalTaimesMatrix] = useState(false);

    const closePopover = () => {
        setShowConfigurationValue(!showConfigurationValue)
    }

    // Simula el evento de handleChangeUpdateSelect para guardar file_special_value.
    const changeFileSpecialValue = (e) => {
        props.handleChangeUpdateSelect({ target: { name: "file_special_value", value: e.target.value } });
    }

    return (
        <React.Fragment>  
            <div className="mb-4">
                <div className="">
                    <div className="row">
                        <div className="col-md-3">
                            <input 
                                type="text" 
                                name="name"
                                className='form form-control'
                                placeholder='Nombre de la fila'
                                value={props.formRow.name}
                                onChange={props.handleChangeRow}
                            />


                            <a
                                className="link-add"
                                onClick={() => props.createRow()}
                            >
                                Agregar
                            </a>

                            <a
                                className="link-remove btn-outline-danger"
                                onClick={() => props.clearValues("row")}
                            >
                                Cancelar
                            </a>
                        </div>

                        {props.questionMatrix.columns.length <= 4 && (
                            <div className="col-md-3">
                                <input 
                                    type="text" 
                                    name="name"
                                    placeholder='Nombre de la columna'
                                    className={`form form-control ${!props.errorValueOptionColumn && props.formColumn.name == "" ? "error-class" : ""}`}
                                    value={props.formColumn.name}
                                    onChange={props.handleChangeColumn}
                                />


                                <a
                                    className="link-add"
                                    onClick={() => props.createColumn()}
                                >
                                    Agregar
                                </a>

                                <a
                                    className="link-remove btn-outline-danger"
                                    onClick={() => props.clearValues("column")}
                                >
                                    Cancelar
                                </a>

                                {(!props.errorValueOptionColumn && props.formUpdateColumn.index == null) && (
                                    <div class="alert alert-danger text-center mt-3" role="alert">
                                        <b>{props.formColumn.name == "" ? "El campo no puede estar vacio" : "No se permiten columnas con el mismo nombre"}</b>
                                    </div>
                                )}
                            </div>
                        )}

                        {props.questionMatrix.columns.length >= 1 && (
                            <div className="col-md-3">
                                <select 
                                    name="default_column"
                                    className='form form-control'
                                    value={props.questionMatrix.default_column}
                                    onChange={props.handleChangeUpdateSelect}
                                >
                                    <option value="radio">Seleccione una opción por defecto</option>
                                    {props.questionMatrix.columns.map((columna, index) => (
                                        <option value={columna} key={index}>{columna}</option>
                                    ))}
                                </select>
                                <label>Opción por defecto</label>
                            </div>
                        )}

                        <div className="col-md-3">
                            <select 
                                name="type_question"
                                className='form form-control'
                                value={props.questionMatrix.type_question}
                                onChange={props.handleChangeUpdateSelect}
                            >
                                {/*<option value="checkbox">Cuadricula de casilla de verificación</option>*/}
                                <option value="radio">Cuadricula de opción múltiple</option>
                                <option value="select">Lista desplegable</option>
                            </select>
                        </div>
                    </div>
                    <div>
                        {props.questionMatrix.set_value && (
                            <div> 
                                <FormConfigurationValue
                                    questionMatrix={props.questionMatrix}
                                    closePopover={closePopover}
                                    question={props.question}
                                    updateQuestionMatrix={props.updateQuestionMatrix}
                                />
                            </div>  
                        )}
                    </div>
                </div>

                <div className={`${isMobile ? ('row mt-3'): ('ui-form-create-matrix__container-switch')}`}> 
                    <div className="col-md-6"></div>
                    <div className="col-md-2">
                        <div className="custom-control custom-switch">
                            <input type="checkbox" onChange={(e) => props.updateBoolean(!props.questionMatrix.has_file, "has_file")} className="custom-control-input" id={`customConfigurationMatrixFile${props.questionMatrix.id}`} checked={props.questionMatrix.has_file} />
                            <label className="custom-control-label" htmlFor={`customConfigurationMatrixFile${props.questionMatrix.id}`}>Archivo</label>
                        </div>
                    </div>

                    <div className="col-md-2 mr-1">
                        <div className="custom-control custom-switch">
                            <input type="checkbox" onChange={(e) => props.updateBoolean(!props.questionMatrix.has_commets, "has_commets")} className="custom-control-input" id={`customConfigurationMatrixComment${props.questionMatrix.id}`} checked={props.questionMatrix.has_commets} />
                            <label className="custom-control-label" htmlFor={`customConfigurationMatrixComment${props.questionMatrix.id}`}>Comentarios</label>
                        </div>
                    </div>

                    <div className="col-md-3 pr-3">
                        <div className="custom-control custom-switch">
                            <input type="checkbox" onChange={(e) => props.updateBoolean(!props.questionMatrix.set_value, "set_value")} className="custom-control-input" id={`customConfigurationMatrixSetValue${props.questionMatrix.id}`} checked={props.questionMatrix.set_value} />
                            <label className="custom-control-label" htmlFor={`customConfigurationMatrixSetValue${props.questionMatrix.id}`}>Asignar valor</label>
                        </div>
                    </div>
                </div>

                {props.questionMatrix.has_file && (
                    <div className="row mt-3 align-items-end">
                        <div className="col-md-4">
                            <label className="mb-1" style={{ fontSize: '0.85em', fontWeight: 600 }}>Tipo de evidencia</label>
                            <select
                                name="file_special_value"
                                className="form form-control"
                                value={props.questionMatrix.file_special_value || ""}
                                onChange={changeFileSpecialValue}
                            >
                                <option value="">Todos los archivos</option>
                                <option value="image">Solo imágenes</option>
                                <option value="camera">Solo cámara</option>
                            </select>
                        </div>
                        {props.aiEnabled && (
                            <div className="col-md-4">
                                <button
                                    type="button"
                                    className="taf-btn taf-btn--soft taf-btn--sm"
                                    onClick={() => setModalTaimesMatrix(true)}
                                >
                                    <i className="fas fa-robot"></i>Configurar IA
                                </button>
                            </div>
                        )}
                    </div>
                )}

            </div>

            {modalTaimesMatrix && (
                <ModalTaimesAgentMatrix
                    modal={modalTaimesMatrix}
                    toggle={() => setModalTaimesMatrix(false)}
                    questionMatrix={props.questionMatrix}
                    onSaved={(cfg) => {
                        // refrescar la config local para que el estado quede sincronizado
                        if (props.updateQuestionMatrix) {
                            props.updateQuestionMatrix(props.question.step_id, props.question.id,
                                { ...props.questionMatrix, taimes_ai_config: cfg });
                        }
                    }}
                />
            )}
        </React.Fragment>
    );
}


export default FormCreate;

